module.exports = __webpack_public_path__ + "static/media/50-honeymoon.c56699b0.jpeg";